export const articles = ({ kb }) => (kb && kb.articles ? kb.articles : [])

export const kb = ({ kb }) => kb

export const allArticles = ({ kb }) => kb.articles

export const articlesScroll = ({ kb }) => kb.scrollId

export const articlesTotal = ({ kb }) => kb.total

export const articlesHasMore = ({ kb }) => kb.hasMore

export const articlesLastDate = ({ kb }) =>
  kb.articles.length ? kb.articles.reduce((c, a) => a.lastUpdate) : undefined

export const articlesCount = ({ kb }) => kb.articles.length

export const kbTyping = ({ kbTyping }) => kbTyping

export const kbSearchLoader = ({ kbSearchLoader }) => kbSearchLoader

export const kbSearchResult = ({ kbSearchResult }) => kbSearchResult

export const currentArticle = ({ currentArticle }) => currentArticle

export const isCurrentArticleLoading = ({ isCurrentArticleLoading }) =>
  isCurrentArticleLoading
